// Components==============
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router';
import { ButtonColor } from 'typings';
import { interactiveScale } from 'utilities/FramerAnimations';
import './CircleButton.module.scss';
// =========================

type Props = {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  to?: string;
  color?: ButtonColor;
  icon: any;
  small?: boolean;
  inactive?: boolean;
};

export default function CircleButton({
  color = 'blue',
  icon,
  onClick,
  to,
  small,
  inactive,
}: Props) {
  const history = useHistory();

  return (
    <motion.button
      type="button"
      onClick={to ? () => history.push(to) : onClick}
      {...interactiveScale}
      styleName={`CircleButton ${color} ${small ? 'small' : ''}`}
      style={
        inactive
          ? {
              pointerEvents: 'none',
              opacity: 0.5,
            }
          : {}
      }
    >
      <FontAwesomeIcon icon={icon} />
    </motion.button>
  );
}
